import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Settings } from '@hub/common/Settings';
import { googleAnalytics } from '@hub/common/google-analytics/GoogleAnalytics';
import { AppConfigService } from '@hub/services/AppConfigService';
import { AuthService } from '@hub/services/AuthService';
import { Subscription } from 'rxjs';

@Component({
  selector: 'my-app',
	templateUrl: 'app.component.html'
})
export class AppComponent {
  private readonly subscriptions = new Subscription();
  initialized: boolean = false;

  constructor(
    private auth: AuthService,
    private appConfigService: AppConfigService,
    private router: Router
  ) {
    // Google analytics
    let environment = Settings.getEnvironment().toUpperCase();
    if (environment === "LIVE" || environment === "STAGING") {
      this.subscriptions.add(this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          setTimeout(() => {
            googleAnalytics(event.urlAfterRedirects);
          }, 20);
        }
      }));
    }
  }

  ngOnInit() {
    this.subscriptions.add(this.appConfigService.getConfigAsObservable().subscribe(config => {
        this.auth.init();
        this.initialized = true;
    }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getInitilized(){
    return this.initialized;
  }
}
